import { NavigationExtras } from '@angular/router';
import { Domains } from '../multi-stage-growth-report/models/multi-stage-growth-report.model';
import { GrowthChartCheckboxSettings, GrowthChartSettings } from './models/common.model';

export enum MultiStageGrowthReportRoutes {
  Error = 'error',
}

export const DEFAULT_NAVIGATION_EXTRAS: Partial<NavigationExtras> = {
  queryParamsHandling: 'merge',
};

export enum SkillDomainKeys {
  OV = 'OV',
}

export enum MSDAComponent {
  OVERALL_SCORE = 'OverallScoreComponent',
  PERFORMANCE_BY_DOMAIN_WRAPPER = 'PerformanceByDomainWrapperComponent',
  ADDITIONAL_RESOURCES = 'AdditionalResourcesComponent',
  METRIC_MEASURE = 'MetricMeasureComponent',
  METRIC_MEASURE_FOOTER = 'MetricMeasureFooterComponent',
  CLASS_AVERAGE_METRIC = 'ClassAverageMetricComponent',
  FORECASTING_CARD = 'ForecastingCardComponent',
}

export enum RoutePath {
  SEARCH_VIEWER = 'search-viewer',
}

export const DEFAULT_SCALE_SCORE_CHART_SETTINGS: GrowthChartSettings = {
  selectedDomain: Domains.OV,
  showClassAverageSeries: true,
  showGrowthCustomBox: true,
};

export const DEFAULT_METRIC_CHART_SETTINGS: GrowthChartCheckboxSettings = {
  showClassAverageSeries: true,
  showGrowthCustomBox: true,
};
